import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { Event } from "../../types/Types";

type UpdateEventDto = Partial<Event>;

/** POST /Event/Create returns this shape (camelCase from System.Text.Json). */
export type CreateEventResponse = {
  id: number;
  eventCode: string;
};

export type SaveEventResult = CreateEventResponse | Event | undefined;

export type SaveEventInput = Partial<Event> | FormData;

function normalizeCreateEventResponse(
  data: unknown
): CreateEventResponse | undefined {
  if (data && typeof data === "object") {
    const o = data as Record<string, unknown>;
    const id =
      typeof o.id === "number"
        ? o.id
        : typeof o.Id === "number"
          ? o.Id
          : undefined;
    const eventCode =
      typeof o.eventCode === "string"
        ? o.eventCode
        : typeof o.EventCode === "string"
          ? o.EventCode
          : undefined;
    if (id !== undefined && eventCode !== undefined) {
      return { id, eventCode };
    }
  }
  return undefined;
}

function getFormDataId(data: FormData): string | number | null {
  const id = data.get("id");
  if (id == null || id === "") return null;
  return typeof id === "string" || typeof id === "number" ? id : null;
}

export const useSaveEvent = (
  options?: UseMutationOptions<
    SaveEventResult,
    unknown,
    SaveEventInput,
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationFn: (data: SaveEventInput) => {
      const isFormData = data instanceof FormData;
      const hasId = isFormData
        ? getFormDataId(data) != null
        : !!(data as UpdateEventDto).id;

      const config = isFormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};

      if (hasId) {
        return axiosInstance
          .put(getAPIURL(`/Event/Update`), data, config)
          .then((res) => res.data as SaveEventResult);
      } else {
        return axiosInstance
          .post(getAPIURL("/Event/Create"), data, config)
          .then((res) => normalizeCreateEventResponse(res.data));
      }
    },
  });
};
